<script>
import DashboardLayout from "../layouts/DashboardLayout.vue";
import Dialog from "primevue/dialog";

export default {
    name: "IntegrationsView",
    components: {
        DashboardLayout,
        Dialog,
    },
    data() {
        return {
            searchQuery: "",
            selectedCategory: "All Apps",
            isConnectModalVisible: false,
            selectedIntegration: null,
            integrations: [
                {
                    key: "ams",
                    name: "AMS",
                    domain: "ams4you.com",
                    logo: "/assets/images/icons/ams4you.png",
                    description: "Sync student, lead and class data with your AMS core records.",
                    category: "Core",
                    accent: "#ef4f2a",
                },
                {
                    key: "gds",
                    name: "GDS",
                    domain: "ams4you.net/gds/provider",
                    logo: "/assets/images/icons/gds.png",
                    description: "The Global Distribution System (GDS), connects your Language Schools and programs directly to a global network of premier international education professionals.",
                    category: "Data",
                    accent: "#1461ff",
                },
                {
                    key: "whatsapp",
                    name: "Whatsapp",
                    domain: "whatsapp.com",
                    logo: "/assets/images/icons/whatsapp.png",
                    description: "Manage Whatsapp chat streams and handoff moments from a single dashboard.",
                    category: "Messaging",
                    accent: "#25d366",
                },
                {
                    key: "instagram",
                    name: "Instagram",
                    domain: "instagram.com",
                    logo: "/assets/images/icons/instagram.png",
                    description: "Reply to Instagram DMs and keep lead intent attached to each thread.",
                    category: "Social",
                    accent: "#c13584",
                },
                {
                    key: "tiktok",
                    name: "Tiktok",
                    domain: "tiktok.com",
                    logo: "/assets/images/icons/tiktok.png",
                    description: "Track campaign messages and conversation conversions from TikTok.",
                    category: "Social",
                    accent: "#111111",
                },
                {
                    key: "facebook-messenger",
                    name: "Facebook Messenger",
                    domain: "messenger.com",
                    logo: "/assets/images/icons/facebook-messenger.png",
                    description: "Route Messenger chats to your agent while preserving conversation history.",
                    category: "Messaging",
                    accent: "#1877f2",
                },
                {
                    key: "zapier",
                    name: "Zapier",
                    domain: "zapier.com",
                    logo: "/assets/images/icons/zapier.png",
                    description: "Trigger no-code automations from chat outcomes and lead actions.",
                    category: "Automation",
                    accent: "#ff5a00",
                },
                {
                    key: "gmail",
                    name: "Gmail",
                    domain: "gmail.com",
                    logo: "/assets/images/icons/gmail.png",
                    description: "Send and log email follow-ups directly from AI conversation flow.",
                    category: "Messaging",
                    accent: "#db4437",
                },
                {
                    key: "google-calendar",
                    name: "Google Calendar",
                    domain: "calendar.google.com",
                    logo: "/assets/images/icons/google-calendar.png",
                    description: "Book meetings and sync availability based on real-time chat context.",
                    category: "Scheduling",
                    accent: "#4285f4",
                },
                {
                    key: "mailchimp",
                    name: "Mailchimp",
                    domain: "mailchimp.com",
                    logo: "/assets/images/icons/mailchimp.png",
                    description: "Create and update audiences from lead interactions and qualification scores.",
                    category: "Marketing",
                    accent: "#ffe01b",
                },
                {
                    key: "zoho",
                    name: "Zoho",
                    domain: "zoho.com",
                    logo: "/assets/images/icons/zoho.png",
                    description: "Connect CRM stages, notes and contact updates without manual exports.",
                    category: "CRM",
                    accent: "#d94136",
                },
                {
                    key: "hubspot",
                    name: "Hubspot",
                    domain: "hubspot.com",
                    logo: "/assets/images/icons/hubspot.png",
                    description: "Push contact enrichment and lifecycle events into Hubspot automatically.",
                    category: "CRM",
                    accent: "#ff7a59",
                },
                {
                    key: "twillo",
                    name: "Twillo",
                    domain: "twilio.com",
                    logo: "/assets/images/icons/twillo.png",
                    description: "Handle SMS delivery, status callbacks and message templates in one place.",
                    category: "Messaging",
                    accent: "#f22f46",
                },
                {
                    key: "salesforce",
                    name: "Salesforce",
                    domain: "salesforce.com",
                    logo: "/assets/images/icons/salesforce.png",
                    description: "Map opportunities, tasks and lead statuses into Salesforce objects.",
                    category: "CRM",
                    accent: "#00a1e0",
                },
                {
                    key: "bitrix",
                    name: "Bitrix",
                    domain: "bitrix24.com",
                    logo: "/assets/images/icons/bitrix.png",
                    description: "Keep Bitrix leads and pipeline events aligned with assistant activity.",
                    category: "CRM",
                    accent: "#00a7e1",
                },
            ],
        };
    },
    computed: {
        categories() {
            const uniqueCategories = [...new Set(this.integrations.map((integration) => integration.category))];
            return ["All Apps", ...uniqueCategories];
        },
        filteredIntegrations() {
            const query = this.searchQuery.trim().toLowerCase();
            return this.integrations.filter((integration) => {
                const categoryMatches = this.selectedCategory === "All Apps" || integration.category === this.selectedCategory;
                if (!categoryMatches) return false;
                if (!query) return true;
                const searchableText = `${integration.name} ${integration.domain} ${integration.description}`.toLowerCase();
                return searchableText.includes(query);
            });
        },
        connectTitle() {
            if (!this.selectedIntegration) return "Connect integration";
            return `Connect ${this.selectedIntegration.name} to AMS`;
        },
        connectLink() {
            if (!this.selectedIntegration) return "";
            return `website.com/integrations/${this.selectedIntegration.key}`;
        },
        connectPermissions() {
            if (!this.selectedIntegration) return [];
            const appName = this.selectedIntegration.name;
            return [
                `Trigger workflows when new events arrive from ${appName}.`,
                `Sync conversation and lead updates to your connected tools.`,
                `Log engagement activity to your reporting stack.`,
                `Route agent actions to team workflows and notifications.`,
                `Integrate ${appName} with your AMS automation flows.`,
            ];
        },
    },
    methods: {
        initials(name) {
            if (!name) return "IN";
            const words = name.split(" ").filter(Boolean);
            if (words.length > 1) {
                return `${words[0][0]}${words[1][0]}`.toUpperCase();
            }
            return name.slice(0, 2).toUpperCase();
        },
        selectCategory(category) {
            this.selectedCategory = category;
        },
        openConnectModal(integration) {
            this.selectedIntegration = integration;
            this.isConnectModalVisible = true;
        },
        closeConnectModal() {
            this.isConnectModalVisible = false;
            this.selectedIntegration = null;
        },
        copyConnectLink() {
            if (!this.connectLink) return;
            navigator.clipboard?.writeText(this.connectLink);
        },
        allowIntegration() {
            this.closeConnectModal();
        },
    },
};
</script>
<template>
    <DashboardLayout title="Integrations" subtitle="Connect tools, messaging channels and CRMs to your AMS AI workspace.">
        <section class="integrations-page">
            <header class="integrations-header">
                <h2 class="integrations-header__title">
                    Browse planned integration
                    <span>apps</span>
                </h2>
                <p class="integrations-header__subtitle">Connect channels, CRMs and marketing tools to manage everything from a single place.</p>

                <div class="integrations-header__search">
                    <input v-model="searchQuery" type="text" placeholder="Search integrations..." />
                    <button type="button" aria-label="Search integrations">
                        <PhMagnifyingGlass :size="16" />
                    </button>
                </div>

                <div class="integrations-header__categories">
                    <button
                        v-for="category in categories"
                        :key="category"
                        type="button"
                        class="integrations-header__chip"
                        :class="{'is-active': selectedCategory === category}"
                        @click="selectCategory(category)"
                    >
                        {{ category }}
                    </button>
                </div>
            </header>

            <section class="integrations-grid">
                <article v-for="integration in filteredIntegrations" :key="integration.key" class="integration-card" :style="{'--card-accent': integration.accent}">
                    <div class="integration-card__body">
                        <div class="integration-card__head">
                            <div class="integration-card__logo-wrap">
                                <img v-if="integration.logo" :src="integration.logo" :alt="`${integration.name} logo`" class="integration-card__logo" />
                                <span v-else class="integration-card__logo-fallback" :style="{'--logo-accent': integration.accent}">
                                    {{ initials(integration.name) }}
                                </span>
                            </div>
                        </div>
                        <div class="integration-card__content">
                            <h3>{{ integration.name }}</h3>
                            <p>{{ integration.description }}</p>
                        </div>
                    </div>

                    <!-- <div class="integration-card__footer">
                        <button type="button" class="integration-card__connect" @click="openConnectModal(integration)">Connect</button>
                    </div> -->
                </article>

                <article v-if="!filteredIntegrations.length" class="integration-card integration-card--empty">
                    <div class="integration-card__body">
                        <h3>No integration found</h3>
                        <p>Try another search term or select a different category.</p>
                    </div>
                </article>
            </section>

            <Dialog v-model:visible="isConnectModalVisible" modal :draggable="false" :closable="false" class="integration-connect-modal">
                <template #container>
                    <div v-if="selectedIntegration" class="integration-connect-modal__container">
                        <section class="integration-connect-modal__top">
                            <div class="integration-connect-modal__logos">
                                <div class="integration-connect-modal__logo integration-connect-modal__logo--dark">
                                    <img v-if="selectedIntegration.logo" :src="selectedIntegration.logo" :alt="`${selectedIntegration.name} logo`" class="integration-connect-modal__logo-image" />
                                    <span v-else>{{ initials(selectedIntegration.name) }}</span>
                                </div>
                                <span class="integration-connect-modal__arrow">↔</span>
                                <div class="integration-connect-modal__logo integration-connect-modal__logo--ams">AMS</div>
                            </div>

                            <h3>{{ connectTitle }}</h3>
                            <p>{{ selectedIntegration.description }}</p>

                            <div class="integration-connect-modal__link-row">
                                <input :value="connectLink" readonly />
                                <button type="button" @click="copyConnectLink">Copy Link</button>
                            </div>
                        </section>

                        <section class="integration-connect-modal__permissions">
                            <h4>{{ selectedIntegration.name }} would like to:</h4>
                            <ul>
                                <li v-for="permission in connectPermissions" :key="permission">
                                    <span class="integration-connect-modal__check">✓</span>
                                    <span>{{ permission }}</span>
                                </li>
                            </ul>
                        </section>

                        <footer class="integration-connect-modal__actions">
                            <button type="button" class="integration-connect-modal__secondary">How it works</button>
                            <div class="integration-connect-modal__actions-right">
                                <button type="button" class="integration-connect-modal__secondary" @click="closeConnectModal">Cancel</button>
                                <button type="button" class="integration-connect-modal__primary" @click="allowIntegration">Allow</button>
                            </div>
                        </footer>
                    </div>
                </template>
            </Dialog>
        </section>
    </DashboardLayout>
</template>

<style scoped>
.integrations-page {
    --bg-page: radial-gradient(circle at 90% -20%, #f7f8ff 0%, #f2f4f9 35%, #edf0f7 100%);
    --bg-card: #ffffff;
    --stroke-soft: #e3e7ef;
    --text-main: #252a38;
    --text-soft: #626a7f;
    --shadow-soft: 0 12px 34px rgba(24, 32, 52, 0.06);
    display: grid;
    gap: 1.25rem;
}

.integrations-header {
    display: grid;
    justify-items: center;
    gap: 0.95rem;
    padding: 2rem 1.5rem 1.2rem;
    border: 1px solid var(--stroke-soft);
    border-radius: 1.25rem;
}

.integrations-header__eyebrow {
    color: #4c4ac8;
    font-size: 0.95rem;
    font-weight: 700;
}

.integrations-header__title {
    margin: 0;
    color: var(--text-main);
    text-align: center;
    font-size: clamp(1.9rem, 4.8vw, 3.5rem);
    line-height: 1.03;
    letter-spacing: -0.02em;
}

.integrations-header__title span {
    display: inline-block;
    padding: 0.08em 0.18em;
    background: #b6f26d;
}

.integrations-header__subtitle {
    margin: 0;
    color: var(--text-soft);
    text-align: center;
    max-width: 46rem;
    font-size: 1.03rem;
    line-height: 1.45;
}

.integrations-header__search {
    width: min(34rem, 100%);
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 0.5rem;
}

.integrations-header__search input {
    width: 100%;
    height: 2.8rem;
    border: 1px solid #d7dde9;
    border-radius: 0.7rem;
    background: #f7f9fd;
    color: #2c3348;
    padding: 0 0.85rem;
    font-size: 0.95rem;
    outline: none;
}

.integrations-header__search input:focus {
    border-color: #8a95b0;
    background: #fff;
}

.integrations-header__search button {
    width: 2.8rem;
    height: 2.8rem;
    border: 0;
    border-radius: 0.7rem;
    background: #0e1017;
    color: #fff;
    font-size: 1.28rem;
    cursor: pointer;
}

.integrations-header__categories {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    justify-content: center;
}

.integrations-header__chip {
    border: 1px solid #dce1ed;
    background: #f2f4f8;
    color: #2a3143;
    border-radius: 0.55rem;
    font-size: 0.78rem;
    font-weight: 700;
    letter-spacing: 0.02em;
    padding: 0.4rem 0.62rem;
    cursor: pointer;
}

.integrations-header__chip.is-active {
    background: #11131a;
    color: #fff;
    border-color: #11131a;
}

.integrations-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 0.95rem;
    max-width: 1500px;
    margin: 0 auto;
}

.integration-card {
    display: grid;
    overflow: hidden;
    border: 1px solid #dfe3ec;
    border-radius: 1rem;
    background: linear-gradient(90deg, color-mix(in srgb, var(--card-accent) 10%, #fff), #fff 45%, #fff 100%);
    transition:
        transform 0.2s ease,
        box-shadow 0.2s ease;
}

.integration-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 26px rgba(18, 24, 38, 0.09);
}

.integration-card__body {
    padding: 1rem;
    display: flex;
    align-items: flex-start;
    gap: 0.75rem;
}

.integration-card__head {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 0.6rem;
}

.integration-card__logo-wrap,
.integration-card__logo,
.integration-card__logo-fallback {
    width: 60px;
    height: 60px;
}

.integration-card__logo {
    border-radius: 0.82rem;
    border: 1px solid #e1e4ea;
    object-fit: contain;
    padding: 0.3rem;
    background: #fff;
}

.integration-card__logo-fallback {
    border-radius: 0.82rem;
    border: 1px solid color-mix(in srgb, var(--logo-accent) 28%, white);
    color: color-mix(in srgb, var(--logo-accent) 84%, #101318);
    background: color-mix(in srgb, var(--logo-accent) 16%, white);
    font-size: 0.85rem;
    font-weight: 900;
    display: grid;
    place-items: center;
}

.integration-card h3 {
    margin: 0;
    color: var(--text-main);
    font-size: 1.03rem;
}

.integration-card p {
    margin: 0;
    color: #596178;
    font-size: 0.875rem;
    line-height: 1.45;
}

.integration-card__footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    border-top: 1px solid #e7eaf1;
    padding: 0.75rem 1rem;
}

.integration-card__connect {
    border: 1px solid color-mix(in srgb, var(--card-accent) 35%, #cfd7e8);
    background: color-mix(in srgb, var(--card-accent) 14%, #ffffff);
    color: #2f3445;
    border-radius: 0.7rem;
    padding: 0.5rem 0.92rem;
    font-size: 0.88rem;
    font-weight: 700;
    cursor: pointer;
}

.integration-card__connect:hover {
    background: color-mix(in srgb, var(--card-accent) 24%, #ffffff);
}

.integration-connect-modal__container {
    width: min(42rem, calc(100vw - 2rem));
    border-radius: 1.1rem;
    overflow: hidden;
    background: #fff;
    box-shadow: 0 22px 44px rgba(15, 22, 35, 0.26);
}

.integration-connect-modal__top,
.integration-connect-modal__permissions,
.integration-connect-modal__actions {
    padding: 1.5rem;
}

.integration-connect-modal__top {
    text-align: center;
    display: grid;
    gap: 0.95rem;
}

.integration-connect-modal__logos {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
}

.integration-connect-modal__logo {
    width: 4.2rem;
    height: 4.2rem;
    border-radius: 999px;
    display: grid;
    place-items: center;
    font-weight: 900;
    letter-spacing: 0.03em;
}

.integration-connect-modal__logo--dark {
    background: #171a22;
    color: #fff;
}

.integration-connect-modal__logo--ams {
    background: #ff5a1f;
    color: #fff;
}

.integration-connect-modal__logo-image {
    width: 2.4rem;
    height: 2.4rem;
    object-fit: contain;
}

.integration-connect-modal__arrow {
    color: #9aa2b5;
    font-size: 2rem;
}

.integration-connect-modal__top h3 {
    margin: 0;
    color: #212632;
    font-size: clamp(1.5rem, 2.7vw, 2.2rem);
}

.integration-connect-modal__top p {
    margin: 0;
    color: #5e667c;
    font-size: 1rem;
    line-height: 1.5;
}

.integration-connect-modal__link-row {
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 0.55rem;
}

.integration-connect-modal__link-row input {
    height: 2.8rem;
    border: 1px solid #d9dfeb;
    border-radius: 0.7rem;
    padding: 0 0.85rem;
    font-size: 1rem;
}

.integration-connect-modal__link-row button {
    height: 2.8rem;
    border: 1px solid #d9dfeb;
    border-radius: 0.7rem;
    padding: 0 0.85rem;
    background: #fff;
    font-size: 1rem;
    font-weight: 700;
    color: #1f2533;
    cursor: pointer;
}

.integration-connect-modal__permissions {
    border-top: 1px solid #e6eaf3;
    border-bottom: 1px solid #e6eaf3;
    display: grid;
    gap: 0.8rem;
}

.integration-connect-modal__permissions h4 {
    margin: 0;
    color: #212632;
    font-size: 1.2rem;
}

.integration-connect-modal__permissions ul {
    list-style: none;
    margin: 0;
    padding: 0;
    display: grid;
    gap: 0.62rem;
}

.integration-connect-modal__permissions li {
    display: flex;
    gap: 0.65rem;
    align-items: flex-start;
    color: #5e667c;
}

.integration-connect-modal__check {
    width: 1.4rem;
    height: 1.4rem;
    border-radius: 999px;
    background: #3980ee;
    color: #fff;
    display: grid;
    place-items: center;
    font-size: 0.88rem;
    flex: 0 0 1.4rem;
}

.integration-connect-modal__actions {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.65rem;
}

.integration-connect-modal__actions-right {
    display: flex;
    align-items: center;
    gap: 0.65rem;
}

.integration-connect-modal__secondary,
.integration-connect-modal__primary {
    border-radius: 0.72rem;
    padding: 0.62rem 1rem;
    font-size: 1.05rem;
    font-weight: 700;
    cursor: pointer;
}

.integration-connect-modal__secondary {
    border: 1px solid #d9dfeb;
    background: #fff;
    color: #1f2533;
}

.integration-connect-modal__primary {
    border: 1px solid #12141c;
    background: #12141c;
    color: #fff;
}

.integration-card--empty {
    grid-column: 1 / -1;
}

@media (max-width: 1120px) {
    .integrations-grid {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}

@media (max-width: 760px) {
    .integrations-page {
        padding: 1rem;
        border-radius: 1rem;
    }

    .integrations-header {
        padding: 1.4rem 0.9rem 1rem;
    }

    .integrations-header__subtitle {
        font-size: 0.95rem;
    }

    .integrations-header__search {
        width: 100%;
    }

    .integrations-header__categories {
        justify-content: flex-start;
    }

    .integrations-grid {
        grid-template-columns: minmax(0, 1fr);
    }

    .integration-card p {
        min-height: auto;
    }

    .integration-connect-modal__top,
    .integration-connect-modal__permissions,
    .integration-connect-modal__actions {
        padding: 1rem;
    }

    .integration-connect-modal__actions {
        flex-direction: column;
        align-items: stretch;
    }

    .integration-connect-modal__actions-right {
        width: 100%;
        justify-content: flex-end;
    }
}
</style>
